// 1 PLN = 17 points
export const ONE_PLN_TO_POINTS_RATIO = 1;

export function pointsToPLN(points: number) {
	// return Math.round((points / ONE_PLN_TO_POINTS_RATIO) * 100) / 100;
	return points / ONE_PLN_TO_POINTS_RATIO;
}

export function plnToPoints(pln: number) {
	// return Math.round(pln * ONE_PLN_TO_POINTS_RATIO);
	return pln * ONE_PLN_TO_POINTS_RATIO;
}

export function getPointsText(points: number) {
	const absolutePoints = Math.abs(points);

	const lastDigit = absolutePoints % 10;
	const lastTwoDigits = absolutePoints % 100;

	if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
		// return 'punktów';
		return 'zł';
	}

	if (lastDigit === 1) {
		// return 'punkt';
		return 'zł';
	}

	if (lastDigit >= 2 && lastDigit <= 4) {
		// return 'punkty';
		return 'zł';
	}

	return 'zł';
}

export function formatPoints(points: number) {
	return `${points} ${getPointsText(points)}`;
}
